import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Projects.css";
// import StackedCards from "./StackedCards"; // Reverted to normal view

const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const categories = [
    "all",
    "web",
    "fullstack",
    "mobile",
    "automation",
    // "machine-learning",
  ];

  const projects = [
    {
      id: 1,
      title: "OuedKniss Scraper",
      description:
        "Desktop scraper that automates data collection from OuedKniss listings with a Tkinter UI and SQLite storage.",
      category: "automation",
      tags: ["Python", "Tkinter", "SQLite", "Web Scraping"],
      github: "https://github.com/faycal-gh/OuedKniss-Scraper-Python-",
      live: "https://github.com/faycal-gh/OuedKniss-Scraper-Python-#readme",
    },
    {
      id: 2,
      title: "TechWomen Event",
      description:
        "Interactive event platform built with TypeScript to showcase speakers, schedule, and resources for TechWomen Algeria.",
      category: "web",
      tags: ["TypeScript", "React", "Tailwind CSS"],
      github: "https://github.com/faycal-gh/TechWomen-Event",
      live: "https://github.com/faycal-gh/TechWomen-Event#readme",
    },
    {
      id: 3,
      title: "i3am Volunteer Manager",
      description:
        "Volunteer management system streamlining shift planning and attendee tracking for Mata3im Rahma community initiatives.",
      category: "fullstack",
      tags: ["React", "Node.js", "MongoDB", "Express"],
      github: "https://github.com/faycal-gh/i3am",
      live: "https://github.com/faycal-gh/i3am#readme",
    },
    {
      id: 4,
      title: "Starrocket",
      description:
        "Space-themed web game featuring canvas rendering, responsive controls, and progressive difficulty levels.",
      category: "web",
      tags: ["HTML", "CSS", "JavaScript", "Canvas"],
      github: "https://github.com/faycal-gh/starrocket",
      live: "https://github.com/faycal-gh/starrocket#readme",
    },
    {
      id: 5,
      title: "Progress Rebuild",
      description:
        "Rebuilding Progress application by leveraging Progress's API to enhance functionality and improve user experience with modern technologies.",
      category: "web",
      tags: [
        "NextJS",
        "Spring Boot",
        "API Integration",
        "PostgreSQL",
        "Spring RestTemplate",
      ],
      github: "https://github.com/faycal-gh/Progress-rebuild",
      live: "https://github.com/faycal-gh/Progress-rebuild#readme",
    },
    {
      id: 6,
      title: "MedClick",
      description:
        "Comprehensive healthcare mobile application connecting patients, pharmacists, and laboratories with smart order dispatch, real-time tracking, prescription uploads, and B2B pharmacy stock exchange. Features intelligent routing, geolocation services, and automated document generation.",
      category: "mobile",
      tags: [
        "React Native",
        "Firebase",
        "React Navigation",
        "TanStack Query",
        "Geolocation",
      ],
      github: "https://github.com/faycal-gh/MedClickMobile/",
      live: "https://github.com/faycal-gh/MedClickMobile/#readme",
    },
    {
      id: 7,
      title: "Maintenance Booking Platform",
      description:
        "Full-stack booking system with Stripe payment integration. Features scheduling, payment processing, webhook handling, admin management, and cron-based automation.",
      category: "fullstack",
      tags: ["Next.js", "Express", "Spring Boot", "PostgreSQL", "Stripe"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
    {
      id: 8,
      title: "FitCloud — Gym SaaS",
      description:
        "Multi-tenant SaaS platform for gyms with membership tracking, attendance, and subscription payments.",
      category: "fullstack",
      tags: ["Next.js", "Express", "Prisma", "PostgreSQL", "Redis"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
    {
      id: 9,
      title: "Full-Stack E-Commerce Platform",
      description:
        "Complete e-commerce system with admin dashboard and real-time sales data visualization.",
      category: "fullstack",
      tags: ["React", "Node.js", "WebSockets"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
    {
      id: 10,
      title: "Rocket Telemetry Dashboard",
      description:
        "Real-time telemetry visualization system displaying live flight data using charts and maps.",
      category: "web",
      tags: ["React", "Data Visualization", "Real-time"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
    {
      id: 11,
      title: "Library Management System",
      description:
        "CRUD system for managing books, users, and borrowing operations with role-based access.",
      category: "fullstack",
      tags: ["Java", "SQL", "Spring Boot"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
    {
      id: 12,
      title: "Driving School Management System",
      description:
        "Scheduling, student tracking, and instructor management system.",
      category: "fullstack",
      tags: ["PHP", "MySQL", "Bootstrap"],
      github: "https://github.com/faycal-gh",
      live: "https://github.com/faycal-gh",
    },
  ];

  const filteredProjects =
    selectedCategory === "all"
      ? projects
      : projects.filter((p) => p.category === selectedCategory);

  return (
    <section id="projects" className="projects section" ref={ref}>
      <motion.div
        className="section-header"
        initial={{ opacity: 0, y: -50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <h2>Some Projects</h2>
      </motion.div>

      <motion.div
        className="project-filters"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-btn ${
              selectedCategory === category ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </motion.div>

      <motion.div
        className="projects-grid"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        {filteredProjects.map((project) => (
          <motion.div
            key={project.id}
            className="project-card"
            whileHover={{ y: -5 }}
            transition={{ duration: 0.2 }}
          >
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag, index) => (
                  <span key={index} className="tag">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="project-links">
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    GitHub
                  </a>
                )}
                {project.live && (
                  <a
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    Live
                  </a>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Projects;
